const getShipmentStatusLabel = (shipmentStatus, intl) => {
  return shipmentStatus ? intl.getLabel(`account.order.shipmentState.${shipmentStatus.toLowerCase()}`) : void 0;
};
export {
  getShipmentStatusLabel
};
//# sourceMappingURL=get-shipment-status-label.js.map
